/**
 * Jeux de maillot du club, pour PRÉ-REMPLIR les couleurs d'un match.
 * COULEURS-MAILLOT-001.
 *
 * Rend `{ kitHome, kitAway, chargement }`. Les deux valeurs sont `''` tant que
 * la requête n'a pas répondu, et le restent si le club n'a rien renseigné.
 *
 * UN PRÉ-REMPLISSAGE, JAMAIS UNE VÉRITÉ. La couleur appartient au match : en
 * amateur, un jeu change en coupe, sur imposition de l'arbitre quand les deux
 * équipes se ressemblent, quand un sponsor en offre un nouveau en cours de
 * saison, ou simplement d'une catégorie à l'autre. Le formulaire affiche donc
 * toujours les deux couleurs en clair, et ce que ce hook rend n'est qu'un
 * point de départ que le coach confirme ou corrige.
 *
 * NE BLOQUE RIEN. Un échec réseau laisse les champs vides plutôt que de faire
 * échouer la page : sans couleurs, l'analyse se fait comme avant ce lot.
 */
import { useEffect, useState } from 'react'
import clubService from '../services/clubService'
import { estCouleurValide } from '../utils/kitColors'

export function useKitColorDefaults() {
  const [etat, setEtat] = useState({ kitHome: '', kitAway: '', chargement: true })

  useEffect(() => {
    let annule = false
    clubService.getMyClub()
      .then((club) => {
        if (annule) return
        setEtat({
          // Une valeur hors contrat en base (import, correction SQL) est
          // ignorée plutôt que proposée : elle vaudrait un 422 à l'analyse.
          kitHome: estCouleurValide(club?.kit_color_home) ? club.kit_color_home : '',
          kitAway: estCouleurValide(club?.kit_color_away) ? club.kit_color_away : '',
          chargement: false,
        })
      })
      .catch(() => {
        if (!annule) setEtat({ kitHome: '', kitAway: '', chargement: false })
      })
    return () => { annule = true }
  }, [])

  return etat
}
